require('./myWalletActualTab.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @components
const Reference = require('../myWalletComponents/reference');
const WalletValues = require('../myWalletComponents/walletValues');
const MyWalletEmptyState = require('../myWalletComponents/myWalletEmptyState');
const StartToInvestButton = require('../myWalletComponents/startToInvestButton');
const MyWalletValuesModal = require('../myWalletValuesModal/myWalletValuesModal');

// @commons
const DonutChart = require('components/d3Components/donutChart/donutChart');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @constants
const {
    MYPROFILE_BROKER_LESS_THAN_ONE,
    TYPE_GESTION_ALTERNATIVA
} = require('constants/index');
const { TYPE_ALTERNATIVE_FUNDS } = require('constants/flagBasedFeatures');

class AssetAllocationTab extends React.Component {
    constructor(props) {
        super(props);
    }

    formatPercentage(percentage, itemsNumber) {
        let roundedValue;

        if((percentage > 0 && percentage < 1) || (percentage === 0 && itemsNumber > 0)) {
            roundedValue = MYPROFILE_BROKER_LESS_THAN_ONE;
        } else {
            //same behavior than Math.round but 0.5 cases will be rounded down.
            roundedValue = -Math.round(-percentage);
        }
        return roundedValue.toString();
    }

    buildReferences() {
        const { immMyWalletCharts, immFlagBasedFeatures } = this.props;

        const hasInvestments = immMyWalletCharts.get('hasInvestments');
        const totalInvestmentAmount = immMyWalletCharts.getIn(['totalInvestment', 'amount']);
        const columns = immMyWalletCharts.get('activePerClassesPercentages').size;
        const modifierClass = columns == 6 ? 'six-columns-with-double-height' : 'five-columns';

        return immMyWalletCharts.get('activePerClassesPercentages')
            .filter(Boolean)
            .map(item => {
                const label = item.get('label');
                const value = item.get('value');
                const percentage = this.formatPercentage(value);
                const name =
                  immFlagBasedFeatures.get(TYPE_ALTERNATIVE_FUNDS) && label === TYPE_GESTION_ALTERNATIVA
                    ? formatText(`brokerAssetClass-privateEquity`)
                    : formatText(`brokerAssetClass-${label}`);

                return (
                    <Reference
                        key={label}
                        id={label}
                        name={name}
                        percentage={percentage}
                        hasInvestments={hasInvestments}
                        totalInvestmentAmount={totalInvestmentAmount}
                        modifierClass={modifierClass}
                    />
                );
            });
    }

    buildDonutChart() {
        const {
            immMyWalletCharts,
        } = this.props;

        const dataset = immMyWalletCharts.get('activePerClassesPercentages');
        const totalInvestmentAmount = immMyWalletCharts.getIn(['totalInvestment','amount'], 0);

        return (
            <DonutChart
                width="180"
                height="180"
                donutWidth="35"
                dataset={dataset.filter(Boolean).map(item => {
                    return item.set('label', formatText(`brokerAssetClass-${item.get('label')}`)).set('key', item.get('label'));
                })}
                namespace="my-wallet-actual-tab"
                totalInvestmentAmount={totalInvestmentAmount}
                valueFormatFunction={this.formatPercentage}
            />
        );
    }

    getContent() {
        const {
            immMyWalletCharts,
            onToggleModal,
            immBrokerMyInvestments
        } = this.props;

        const summarizationData = immMyWalletCharts.get('summarizationData');
        const hasInvestments = immMyWalletCharts.get('hasInvestments');
        const hasPendingOperations = immMyWalletCharts.get('hasPendingOperations');
        const isCustomWalletSelected = immMyWalletCharts.get('isCustomWalletSelected');
        const startToInvestButton = !hasInvestments && !isCustomWalletSelected
        ? (
            <StartToInvestButton
                label={formatText('broker-miCarteraEmptyStateCTALabel')}
            />) : null;
        const donutChart = this.buildDonutChart();
        const references = this.buildReferences();
        const modaleIsOpen = immMyWalletCharts.get('showModal')

        return (
            <div>
                <div>
                    <div className="my-wallet-actual-tab__donut-container col-xs-4">
                        {donutChart}
                    </div>
                    <div className="my-wallet-actual-tab__content col-xs-8">
                        <WalletValues
                            immMyWalletCharts={immMyWalletCharts}
                            handleHowCalculateOnClick={onToggleModal}
                            immBrokerMyInvestments={immBrokerMyInvestments}
                        />
                    </div>
                    <div className="my-wallet-actual-tab__ref-container my-wallet-actual-tab__ref-container-tab-assets col-xs-12">
                        {references}
                    </div>
                    {startToInvestButton}
                </div>
                <MyWalletValuesModal
                    isOpen={modaleIsOpen}
                    onRequestClose={onToggleModal}
                    hasPendingOperations={hasPendingOperations}
                    onToggleModal={onToggleModal}
                    summarization={summarizationData}
                    />
            </div>
        )
    }

    render() {
        const {
            immMyWalletCharts,
            handleRetry,
            brokerMyInvestmentsErrorReceived,
            isFetchingMyInvestment
        } = this.props;

        let tabContent;

        if (isFetchingMyInvestment) {
            tabContent = <LoadingSection />;
        } else if (immMyWalletCharts.get('fetchError') || brokerMyInvestmentsErrorReceived) {
            tabContent = MyWalletEmptyState(handleRetry);
        } else if (!immMyWalletCharts.get('fetchError') && !brokerMyInvestmentsErrorReceived) {
            tabContent = this.getContent();
        }

        return (
            <div className="my-wallet-actual-tab row">
                {tabContent}
            </div>
        );
    }
}

AssetAllocationTab.propTypes = {
    immMyWalletCharts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immStocksByType: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    handleRetry: PropTypes.func.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    brokerMyInvestmentsErrorReceived: PropTypes.bool,
    isFetchingMyInvestment: PropTypes.bool
};

module.exports = AssetAllocationTab;
